import { pluginKey } from './plugin-key';
export var ACTION_OPEN_POPUP = 'OPEN_POPUP';
export var ACTION_CLOSE_POPUP = 'CLOSE_POPUP';
var setPopupMeta = function setPopupMeta(_ref) {
  var type = _ref.type,
    tr = _ref.tr,
    mountInfo = _ref.mountInfo;
  return tr.setMeta(pluginKey, {
    type: type,
    mountInfo: mountInfo
  });
};
export var showMediaInsertPopup = function showMediaInsertPopup(tr, mountInfo) {
  return setPopupMeta({
    type: ACTION_OPEN_POPUP,
    mountInfo: mountInfo,
    tr: tr
  });
};
export var closeMediaInsertPicker = function closeMediaInsertPicker(tr) {
  return setPopupMeta({
    type: ACTION_CLOSE_POPUP,
    tr: tr
  });
};